import { render, staticRenderFns } from "./mySourcingDetails.vue?vue&type=template&id=c1faf188&scoped=true&"
import script from "./mySourcingDetails.vue?vue&type=script&lang=js&"
export * from "./mySourcingDetails.vue?vue&type=script&lang=js&"
import style0 from "./mySourcingDetails.vue?vue&type=style&index=0&id=c1faf188&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1faf188",
  null
  
)

export default component.exports